import { api } from './index';

import type { UploadType } from '@/types';

export interface PresignUploadRequest {
  contentLength: number;
  contentType: string;
  filename?: string;
  entityId: string;
  type: UploadType;
}

export interface PresignUploadResponse {
  headers: [string, string][];
  key: string;
  publicUrl: string;
  uploadUrl: string;
}

export const uploadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    presignUpload: builder.mutation<
      PresignUploadResponse,
      PresignUploadRequest
    >({
      query: ({ contentLength, contentType, entityId, filename, type }) => ({
        url: '/uploads/presign',
        method: 'POST',
        data: {
          contentLength,
          contentType,
          entityId,
          filename,
          type,
        },
      }),
    }),
  }),
});

export const { usePresignUploadMutation } = uploadApi;
